import { render, staticRenderFns } from "./MatrEditList.vue?vue&type=template&id=0b49645f&scoped=true&"
import script from "./MatrEditList.vue?vue&type=script&lang=js&"
export * from "./MatrEditList.vue?vue&type=script&lang=js&"
import style0 from "./MatrEditList.vue?vue&type=style&index=0&id=0b49645f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b49645f",
  null
  
)

export default component.exports